
import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = ['root', 'sun', 'moon'];

    initialize() {
        let theme = this.getTheme();
        if (theme !== 'dark' && theme !== 'light') {
          theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
          this.setTheme(theme);
        }
        this.rootTarget.classList.add(theme);
        this.rootTarget.classList.remove(theme === 'dark' ? 'light' : 'dark');
        // daisyUI switches its theme CSS vars off a `data-theme` attribute,
        // not off Tailwind's `dark:` class — keep both in sync so daisyUI
        // components (DateRangePickerComponent, etc.) follow the same toggle.
        this.rootTarget.setAttribute('data-theme', theme);
        this.changeInput(theme);
    }

    onClick(event){
        if(this.getTheme() === 'dark'){
          this.setTo('light', 'dark')
        }else {
          this.setTo('dark', 'light')
        }
    }

    setTo(theme, from){
        this.setTheme(theme)
        this.rootTarget.classList.add(theme)
        this.rootTarget.classList.remove(from)
        this.rootTarget.setAttribute('data-theme', theme)
        this.changeInput(theme)
    }

    changeInput(theme){
      if(theme === 'dark') {
        this.sunTarget.classList.add('hidden')
        this.moonTarget.classList.remove('hidden')
      } else {
        this.sunTarget.classList.remove('hidden')
        this.moonTarget.classList.add('hidden')
      }
    }


    setTheme(theme) {
        localStorage.setItem('color-theme', theme)
    }

    getTheme() {
        return localStorage.getItem('color-theme')
    }

}